import React from 'react';

import { useGetFundFromOrigin } from '@api/funds/api.funds.queries';
import { useAuth } from '@components/utilComponents/AuthProvider';

import { carrotQuest, carrotQuestAuth } from './helpers';
import { useCarrotQuestScript } from './hooks';

export const CarrotQuestManager: React.FC = () => {
  const user = useAuth();
  const { data: fund } = useGetFundFromOrigin();

  const carrotQuestInstance = React.useMemo(() => {
    // `cq_api_key` в схеме необязателен и nullable, поэтому проверяем сам ключ,
    // а не только наличие фонда: без него виджет инициализировался бы с
    // `undefined` вместо идентификатора. Рукописный тип объявлял поле
    // обязательным и прятал это (AF-14).
    if (!fund?.cq_api_key) return;
    return carrotQuest({ id: fund.cq_api_key });
  }, [fund]);

  const isScriptReady = useCarrotQuestScript(carrotQuestInstance);

  React.useEffect(() => {
    if (isScriptReady && user) {
      carrotQuestAuth(user, user?.user_carrot_quest_hash);
    }
  }, [isScriptReady, user]);

  return '';
};
